/* PupandTote: shows the automatic-discount price in the shopper's currency.
   Only touches elements rendered with data-ap (non-USD currencies). The
   discount itself is applied by Shopify at cart and checkout. */
(function () {
  'use strict';
  function run() {
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur ? parseFloat(cur.rate) : NaN;
    var code = cur && cur.active;
    if (!rate || !code) return;
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code }); }
    catch (e) { return; }
    function money(cents) { return fmt.format(cents / 100); }

    document.querySelectorAll('[data-ap]').forEach(function (el) {
      var price = parseInt(el.getAttribute('data-ap-price'), 10);
      var offBase = parseInt(el.getAttribute('data-ap-off'), 10);
      var qty = parseInt(el.getAttribute('data-ap-qty'), 10) || 1;
      if (!price || !offBase) return;
      var off = Math.round(offBase * rate);
      if (off <= 0 || off >= price) return; /* keep the plain price, no discount claim */
      var finalTotal = (price - off) * qty;
      var saveTotal = off * qty;
      var origTotal = price * qty;

      if (el.tagName === 'OPTION') {
        el.textContent = (el.getAttribute('data-ap-label') || '') + ' — ' + money(finalTotal) + (el.getAttribute('data-ap-suffix') || '');
        return;
      }
      el.querySelectorAll('[data-ap-final]').forEach(function (n) { n.textContent = money(finalTotal); });
      el.querySelectorAll('[data-ap-save]').forEach(function (n) {
        n.textContent = n.getAttribute('data-ap-save') === 'pct'
          ? 'SAVE ' + Math.round(saveTotal * 100 / origTotal) + '%'
          : 'SAVE ' + money(saveTotal);
      });
      el.classList.remove('ap-pending');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
